/**
 * Converts arbitrary text into a URL/anchor-safe slug.
 *
 * Used for blog article URLs, hrefs, and in-page heading anchors.
 * Any non-alphanumeric run becomes a single `-`,
 * and leading/trailing hyphens are trimmed.
 *
 * This particular implementation is chosen for its backwards compatibility with
 * the older slugify function used in by the blog, to preserve existing links.
 */

export const slugifyText = (text: string): string =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
